//
//
//
//
//
//
//
//
//
//
//

import ListedSingleCoin from '~/components/detail/listed_single_coin'
export default {
  name: 'CoinsNew',
  components: { ListedSingleCoin }
}
